export const getGenderValue = (key) => {
    const genderMap = { "0": "Female", "1": "Male", "2": "Others" };
    return genderMap[key] || "";
};

export const getValuesByKeyList = (list, keys) => {
    if (!keys) return "";
    const keyArray = keys.includes(",") ? keys.split(",") : [keys];
    return keyArray
        .map((key) => {
            const item = list?.find((o) => o.key === key);
            return item ? item.label : "";
        })
        .join(" ");
};

export const getListByKeys = (list, keys) => {
    if (!keys) return [];
    const keyArray = keys.includes(",") ? keys.split(",") : [keys];
    return list?.filter((item) => keyArray.includes(item.key));
};

export const getObjectByKey = (list, key) => {
    return list?.find((o) => o.key === key) || {};
};

export const getObjectByLabel = (list, label) => {
    return list?.find((o) => o.label === label) || {};
};

export const getObjectLabel = (str) => {
    try {
        const obj = JSON.parse(str);
        return obj?.label || "";
    } catch (e) {
        return "";
    }
};

export const getObjectKey = (str) => {
    try {
        const obj = JSON.parse(str);
        return obj?.key || "";
    } catch (e) {
        return "";
    }
};

export const getValue = (obj) => (obj && obj?.value ? obj?.value : "");

export const getLabel = (obj) => (obj && obj?.label ? obj?.label : "");

export const getKey = (obj) => {
    return obj && obj?.key ? obj?.key : "";
};

export const getKeys = (list) => {
    return list?.map((item) => item.key).toString() || "";
};

export const stringToObject = (str) => {
    try {
        return JSON.parse(str);
    } catch (e) {
        return {};
    }
};

const isObject = (value) => typeof value === "object" && value !== null;

export const getLocationByObject = (customObject) => {
    let locationParts = [];
    if (customObject.address_line1) locationParts.push(customObject.address_line1);
    if (customObject.address_line2) locationParts.push(customObject.address_line2);
    if (isObject(customObject.city)) locationParts.push(stringToObject(customObject.city).label);
    if (isObject(customObject.state)) locationParts.push(stringToObject(customObject.state).label);
    if (isObject(customObject.country)) locationParts.push(stringToObject(customObject.country).label);
    return locationParts.join("\n");
};

// Utility for calculations
export const calculateProductValues = (formData, changedField) => {
  let rate = parseFloat(formData.item.rate_per_quantity) || 0;
  const qty = parseFloat(formData.item.quantity) || 0;
  let discountPercent = parseFloat(formData.item.discount) || 0;
  let discountAmount = parseFloat(formData.item.discount_amount) || 0;
  const taxRate = parseFloat((formData.item.tax || "0").split(",")[0]) || 0;
  let netAmount = parseFloat(formData.item.net_amount) || 0;

  if (changedField === "item.net_amount" && qty > 0) {
    const totalAfterDiscount = netAmount / (1 + taxRate / 100);
    const baseAmount = totalAfterDiscount / (1 - discountPercent / 100);
    rate = baseAmount / qty;
  }

  const baseAmount = rate * qty;

  if (!baseAmount || baseAmount <= 0) {
    return {
      amount: '0.00',
      discount: '0.00',
      discount_amount: '0.00',
      total_amount: '0.00',
      tax_amount: '0.00',
    };
  }

  if (changedField === 'item.discount') {
    discountAmount = baseAmount * (discountPercent / 100);
  } else if (changedField === 'item.discount_amount') {
    discountPercent = (discountAmount / baseAmount) * 100;
  }

  const totalAfterDiscount = baseAmount - discountAmount;
  const taxAmount = totalAfterDiscount * (taxRate / 100);
  const netAmountCalculated = totalAfterDiscount + taxAmount;

  // Build return object dynamically
  const result = {
    amount: baseAmount.toFixed(2),
    total_amount: totalAfterDiscount.toFixed(2),
    tax_amount: taxAmount.toFixed(2),
  };

  if (changedField !== 'item.discount') {
    result.discount = discountPercent.toFixed(2);
  }
  if (changedField !== 'item.discount_amount') {
    result.discount_amount = discountAmount.toFixed(2);
  }
  if (changedField !== 'item.net_amount') {
    result.net_amount = netAmountCalculated.toFixed(2);
  }
  if (changedField !== 'item.rate_per_quantity') {
    result.rate_per_quantity = rate.toFixed(2);
  }

  return result;
};


  export const calculateBaseDetails = (formData, changedField) => {
    const totalAmount = parseFloat(formData.total_amount) || 0;
    let taxAfterDiscountPercent = parseFloat(formData.tax_after_discount) || 0;
    let taxAfterDiscountAmount = parseFloat(formData.tax_after_discount_amount) || 0;
    let roundOff = parseFloat(formData.round_off) || 0;
  
    let netAmount = totalAmount;
  
    // Bi-directional tax calculation
    if (changedField === 'tax_after_discount') {
      taxAfterDiscountAmount = (totalAmount * taxAfterDiscountPercent) / 100;
      roundOff = 0;
    } else if (changedField === 'tax_after_discount_amount') {
      taxAfterDiscountPercent = (taxAfterDiscountAmount * 100) / totalAmount;
      roundOff = 0;
    }
  
    // Subtract tax after discount
    netAmount -= taxAfterDiscountAmount;
  
    // Subtract round off if changed
    if (changedField === 'round_off' && !isNaN(roundOff)) {
      netAmount -= roundOff;
    }
  
    return {
      tax_after_discount: changedField === 'tax_after_discount_amount'
        ? taxAfterDiscountPercent.toFixed(2)
        : formData.tax_after_discount,
      tax_after_discount_amount: changedField === 'tax_after_discount'
        ? taxAfterDiscountAmount.toFixed(2)
        : formData.tax_after_discount_amount,
      round_off: changedField !== 'round_off'
        ? roundOff.toFixed(2)
        : formData.round_off,
      net_amount: netAmount.toFixed(2),
      net_total: netAmount.toFixed(2),
    };
  };
  

 